/** Copyright (C) 2023 Trend Micro Inc. All rights reserved. */

import { API_FSS_PATH, API_CLOUD_ACCOUNT_PATH } from '@constants/api'
import { RUNTIME_ENV_VITE_IS_DEV } from '@constants/viteEnv'

export const generateApiPrefixEnv = () => {
  let env = ''

  if (typeof window !== 'undefined') {
    if (window?.location?.hostname?.indexOf('dev-') > -1) {
      env = 'dev-'
    }
    if (window?.location?.hostname?.indexOf('staging-') > -1) {
      env = 'staging-'
    }
  }

  return env
}

export const genAPIDomain = (
  region = 'us-1',
  service: typeof API_FSS_PATH | typeof API_CLOUD_ACCOUNT_PATH = API_FSS_PATH
) =>
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === 'test' ||
    RUNTIME_ENV_VITE_IS_DEV)
    ? typeof IS_MOCK_NODE_API !== 'undefined' && IS_MOCK_NODE_API
      ? 'http://localhost:3004' // Develop on Safari
      : ''
    : `https://${service}.${region}.${generateApiPrefixEnv()}cloudone.trendmicro.com`
